import { apiGet } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import {
  FraternityListParams,
  FraternityListResponse,
} from '@/constants/types';

class FraternityService {
  async list(params: FraternityListParams): Promise<FraternityListResponse> {
    try {
      const queryParams = new URLSearchParams();
      if (params.sortDir) queryParams.append('sortDir', params.sortDir);
      if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
      if (params.offset !== undefined) queryParams.append('offset', params.offset.toString());
      if (params.search_string !== undefined) queryParams.append('search_string', params.search_string);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);

      const url = `${API_ENDPOINTS.FRATERNITY.LIST}?${queryParams.toString()}`;
      const response = await apiGet<FraternityListResponse>(url, { showLoader: true });
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch fraternities');
    }
  }
}

export const fraternityService = new FraternityService();
